import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import FieldError from '../Fragments/FieldError';
import HelpIcon from '../Fields/HelpIcon';
import HelpText from '../Fields/HelpText';
import ChildQuestion from './ChildQuestion';

let Validation = require('../Managers/Validation.js');
let Quote = require('../Managers/Quote.js');
let Questions = require('../Managers/Questions.js');

const SelectElement = React.createClass({
    propTypes: {
        options:      React.PropTypes.array.isRequired,
        question:     React.PropTypes.string.isRequired,
        fieldName:    React.PropTypes.string.isRequired,
        helpText:     React.PropTypes.string,
        questionId:     React.PropTypes.string,
        defaultValue: React.PropTypes.string,
        children: React.PropTypes.array,
    },

    getDefaultProps() {
        return {
            defaultValue: "Please select..."
        };
    },

    getInitialState: function() {
        return {
            isHelpVisible: false,
            activeValue: (Quote.hasAnswer(this.props.fieldName) !== null) ? Quote.getCurrentAnswer(this.props.fieldName) : false,
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
            hasError: false,
            errors: null,
            childObjects: Questions.getChildren(this.props.children),
            showChildren: Questions.childrenAreActive(this.props.children, this.props.fieldName),
            childrenToUse: Questions.getChildQuestions(this.props.questionId, Quote.getCurrentAnswer(this.props.fieldName)),
        };
    },

    setActiveValue(event) {
        if (null !== event.target.value) {
            let value = event.target.value;
            let validation = Validation.validate(this.props.fieldName, event.target.value)[0];
            this.setState(validation);
            if (validation.isValid) {
                this.setState({
                    activeValue: event.target.value,
                    childrenToUse: Questions.getChildQuestions(this.props.questionId, value),
                    isValid: true,
                });
                Quote.set(this.props.fieldName, event.target.value);
            }

            if (this.state.childObjects !== null) {
                let showChildren = this.state.childObjects.some(function(child) {
                    return (child.key == value);
                });
                this.setState({
                    showChildren
                });
            }
        }
    },

    doValidation() {
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    helpVisibility() {
        if (this.state.isHelpVisible) {
            this.setState({
                isHelpVisible: false,
            });
        } else {
            this.setState({
                isHelpVisible: true,
            });
        }
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    render: function() {
        const self = this;
        const options = self.props.options.map(function(item, index) {
            return (
                <option key={index} value={item.option_value}>{item.option_text}</option>
            );
        }, this);

        let topClass = (this.props.helpText) ? 'question-top with-help' : 'question-top without-help';

        return (
            <div>
            <question-row id={Questions.guid()}>
                <div className="question-main">
                    <div className={topClass}>
                        <label>{this.props.question}</label>
                        {this.props.helpText ? <HelpIcon onClick={this.toggleHelpText} />: null}
                    </div>

                    <div className="question-input">
                        <select
                            name={this.props.fieldName}
                            id={this.props.fieldName}
                            onChange={this.setActiveValue}
                            value={this.state.activeValue}
                            >
                            <option value="">{this.props.defaultValue}</option>
                            {options}
                        </select>
                        {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null}
                        {this.state.hasError ? <FieldError errors={this.state.errors} /> : null }
                    </div>
                </div>
                <div className="question-extra">
                    <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                </div>
            </question-row>
            <child-questions>
            {this.state.childrenToUse !== null ?
                this.state.childrenToUse.map(function(child, index) {
                    return (
                        <ChildQuestion
                            show={this.state.showChildren}
                            key={index+'_'+Questions.guid()}
                            question={child.question}
                            questionId={child.question_id}
                            fieldName={child.field_name}
                            supplementaryId={child.supplementary_id}
                            type={child.type}
                            options={child.options}
                            display_dependencies={child.display_dependencies}
                            parent={child.parent}
                            helpText={child.hint_text}
                         />
                    );
                }, this)

            : null}
            </child-questions>
            </div>
        );
    }
});

export default SelectElement;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/SelectElement.js
 **/